// @flow

import React from "react";
import { localize } from "redux-i18n";
import classNames from "classnames";

type Props = $Exact<{
  data: Array<Object>,
  onSelect: Function,
  title: string,
  limit: number,
  titleClassName?: string,
  ...PropsFromLocalize,
}>;

type ComponentState = $Exact<{
  showPerPage: number,
  startShowIdx: number,
}>;

export class GSCarousel extends React.Component<Props, ComponentState> {
  state = {
    showPerPage: this.props.limit,
    startShowIdx: 0,
  };

  get data() {
    return this.props.data.map((r: Object) => {
      return {
        ...r,
      };
    });
  }

  get paginatedData() {
    const startShowIdx = this.state.startShowIdx;
    return this.data.map((r: Object, idx: number) => {
      return {
        ...r,
        hidden: idx > startShowIdx + (this.props.limit - 1) || idx < startShowIdx,
      };
    });
  }

  nextPage = () => {
    const { showPerPage, startShowIdx } = this.state;
    const totalItems = this.paginatedData.length;
    this.setState({
      startShowIdx: startShowIdx + showPerPage >= totalItems ? startShowIdx : startShowIdx + 1,
    });
  };

  prevPage = () => {
    const { showPerPage, startShowIdx } = this.state;
    this.setState({
      startShowIdx: startShowIdx <= 0 ? startShowIdx : startShowIdx - 1,
    });
  };

  render() {
    const { showPerPage, startShowIdx } = this.state;
    return (
      <div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className={this.props.titleClassName}>{this.props.title}</h4>
          <div className="d-flex flex-column">
            {showPerPage < this.paginatedData.length && (
              <div className="d-flex justify-content-end">
                <span className="material-icons fs-34 cursor-pointer" onClick={this.prevPage}>
                  chevron_left
                </span>
                <span className="material-icons fs-34 cursor-pointer" onClick={this.nextPage}>
                  chevron_right
                </span>
              </div>
            )}
          </div>
        </div>
        <div className="grid-columns-4-500">
          {this.paginatedData.map((el: Object, idx: number) => {
            return (
              <div
                className={classNames(
                  "cursor-pointer gs-card justify-content-around gs-container gs-hover",
                  el.className,
                  {
                    "d-none": el.hidden,
                    active: el.isActive === true,
                    inactive: el.isActive === false,
                  },
                )}
                onClick={e => {
                  e.stopPropagation();
                  el.onSelect(el);
                }}
                key={el.name}
              >
                <div className="cover">
                  <img src={el.path} width={1000} height={260} />
                </div>
                {el.footerItem ? (
                  <div className="p-2 fs-14 d-flex justify-content-between">
                    {el.name}
                    {el.footerItem}
                  </div>
                ) : (
                  <div className="p-2 fs-14">{el.name}</div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default localize()(GSCarousel);
